<template>
  <section class="grey lighten-3">
    <v-container
      grid-list-xl
      fluid
      py-8
    >
      <v-layout
        wrap
        justify-center
      >
        <v-flex
          xs12
          md10
          lg9
          xl7
          mx-auto
        >
          <v-layout wrap>
            <v-flex
              xs12
              class="display-2 mt-4 mb-2 font-weight-light"
            >
              Services
            </v-flex>

            <v-flex
              xs12
              class=""
            >
              <p>
                We are Australia’s leading experts in the defined benefit superannuation schemes available to Commonwealth employees and Australian Defence Force personnel, including the Public Sector Superannuation Scheme (PSS), Commonwealth Superannuation Scheme (CSS), Defence Force Retirement and Death Benefits Scheme (DFRDB), and the Military Superannuation and Benefits Scheme (MSBS / MilitarySuper).
                <br>
                <br>
                Our experts can help with valuing your defined benefit superannuation for family law settlements, or answering your questions about how your defined benefit works, including member and employer contributions, the effects of taking leave, benefit accruals, benefit options, and the family law splitting process.
              </p>
            </v-flex>
            
            <v-flex
              xs12
              md6
            >
              <v-card>
                <v-img
                  src="https://firebasestorage.googleapis.com/v0/b/super-info.appspot.com/o/assets%2Fconsult.jpg?alt=media&token=3a80c113-2077-4ba8-8570-db6158d36b82"
                  lazy-src="https://firebasestorage.googleapis.com/v0/b/super-info.appspot.com/o/assets%2Fthumb_consult.jpg?alt=media&token=bb108716-4b80-4061-b4bd-0f6bbe27e0f6"

                  height="200px"
                />
                <v-responsive :min-height="height">
                  <v-card-title class="headline">
                    Super Info Consult
                  </v-card-title>

                  <v-card-subtitle> 
                    Private superannuation consultations with Dan Blackman who is Australia’s leading expert on the defined benefit schemes for Commonwealth and Australian Defence Force employees.
                  </v-card-subtitle>
                </v-responsive>


                <v-card-actions>
                  <v-spacer />
                  
                  <v-btn
                    color="primary"
                    text
                    to="/services/consulting"
                  >
                    Learn more
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    to="/services/bookings"
                  >
                    Book now
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-card>
                <v-img
                  src="https://firebasestorage.googleapis.com/v0/b/super-info.appspot.com/o/assets%2Fassist.jpg?alt=media&token=0272e1af-a392-41c7-aa72-78760fa0a7be"
                  lazy-src="https://firebasestorage.googleapis.com/v0/b/super-info.appspot.com/o/assets%2Fthumb_assist.jpg?alt=media&token=63bb7112-9365-4385-b801-66a46ffa268d"
                  height="200px"
                />

                <v-responsive :min-height="height">
                  <v-card-title class="headline">
                    Super Info Assist
                  </v-card-title>

                  <v-card-subtitle> 
                    Have one of our experts perform your calculation for you. We verify you have the necessary information and ensure your calculation is performed using the correct method.
                  </v-card-subtitle>
                </v-responsive>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    depressed
                    text
                    to="/assistance"
                  >
                    Get started 
                  <!-- <v-icon right>arrow_forward</v-icon> -->
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
// import { mapGetters } from 'vuex'
// import helpers from '@/mixins/helpers'

export default {
  // mixins: [ helpers ],
  props: {},
  data: () => ({
    height: 130
  }),
};
</script>

<style lang="scss" scoped>
</style>